<template>
  <div class="schema-weights">
    <label :class="{ required: field.required }">
      {{ field.label || 'Weights' }}
      <SVGIcon
        v-if="field.description"
        v-tooltip="field.description"
        :iconName="'info-square'"
        class="info-icon"
      />
    </label>
    <div class="schema-weights__source">
      <div class="schema-weights__option">
        <input
          :id="`weights-default-${parent}-${field.name}`"
          v-model="useDefault"
          type="radio"
          :name="`weights-source-${parent}-${field.name}`"
          :value="true"
        >
        <label :for="`weights-default-${parent}-${field.name}`">{{ defaultLabel }}</label>
      </div>
      <div class="schema-weights__option">
        <input
          :id="`weights-session-${parent}-${field.name}`"
          v-model="useDefault"
          type="radio"
          :name="`weights-source-${parent}-${field.name}`"
          :value="false"
        >
        <label :for="`weights-session-${parent}-${field.name}`">Training Session</label>
      </div>
    </div>
    <SchemaTrainer
      v-if="!useDefault"
      v-model="cascade"
      :field="cascadeField"
      :parent="`${parent}-${field.name}`"
    />
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import SVGIcon from '@/components/SVGIcon.vue';
import SchemaTrainer from '@/components/Schema/SchemaTrainer.vue';
import { defaultWeightsLabel, weightsExtensions, weightsValue } from '@/utils/weightsSource';

const props = defineProps({
  parent: {
    type: String,
    default: '',
  },
  field: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:modelValue']);

const useDefault = ref(true);
// The project/experiment/session cascade stays local; only weightsValue() is emitted so
// the backend's recursive key search never sees project_id, experiment_id or train_session_id.
const cascade = ref({});
const defaultLabel = computed(() => defaultWeightsLabel(props.field));
const cascadeField = computed(() => ({
  name: `${props.field.name}_session`,
  enable_artifacts: true,
  artifacts_filter: weightsExtensions(props.field),
  model_type: props.field.model_type,
}));

watch([useDefault, cascade], () => {
  emit('update:modelValue', weightsValue(useDefault.value, cascade.value?.train_session_id, cascade.value?.artifact));
}, { deep: true, immediate: true });
</script>

<style scoped>
.schema-weights__source {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  margin: 6px 0;
}

.schema-weights__option {
  display: flex;
  align-items: center;
}

.schema-weights__option label {
  padding-left: 5px;
  color: #383c48;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
}
</style>
